import { visit } from 'unist-util-visit';

import createNode from '../utils/create-node';
import { MappedTokenType } from '../utils/get-news-article-data';

// matches sequence of char between {{ and }} and is between 2 -> 8 chars. no spaces
// examples = {{SOL}}, {{BTC}}, {{NOTWORKTOKEN}}
const TOKEN_REGEX_MATCH = /{{([^\s]{2,8})}}/;

export const inlineTokenTicker = (inlineTokenData: MappedTokenType = {}) => {
    return (tree: any) => {
        visit(tree, 'text', (node: any, index: any, parent: any) => {
            if (!parent || typeof index !== 'number' || typeof node.value !== 'string') {
                return;
            }

            const matches = node.value.match(new RegExp(TOKEN_REGEX_MATCH.source, 'g'));
            if (!matches) return;

            const newNodes: any[] = [];
            let remainingText = node.value;

            matches.forEach((match: any, index: number) => {
                const [fullMatch, content] = match.match(TOKEN_REGEX_MATCH) || [];
                if (!fullMatch) return;

                const [before, after] = remainingText.split(fullMatch, 2);

                if (before) newNodes.push({ type: 'text', value: before });

                const assetData = inlineTokenData?.[content];
                if (assetData) {
                    const componentNode = createNode({
                        id: `inline-ticker-id-${index}`,
                        tagName: 'inline-ticker',
                        data: assetData,
                    });
                    newNodes.push(componentNode);
                }

                remainingText = after || '';
            });

            if (remainingText) newNodes.push({ type: 'text', value: remainingText });

            parent.children.splice(index, 1, ...newNodes);
        });
    };
};

export const generateTokenRequestNames = (callback: (tokenNames: string[]) => void) => {
    return (tree: any) => {
        const tokenNames = new Set<string>();

        visit(tree, 'text', (node: any, index: any, parent: any) => {
            if (!parent || typeof index !== 'number' || typeof node.value !== 'string') {
                return;
            }

            const matches = node.value.match(new RegExp(TOKEN_REGEX_MATCH.source, 'g'));
            if (!matches) return;

            matches.forEach((match: any) => {
                const [fullMatch, content] = match.match(TOKEN_REGEX_MATCH) || [];
                if (!fullMatch) return;

                tokenNames.add(content);
            });
        });

        return callback(Array.from(tokenNames));
    };
};
